import * as Immutable from 'immutable';
import { handleActions } from 'redux-actions';

import { AchievementsActionType, AchievementsStore, BaseAchievementElement } from './AchievementsReducer.types';

// @ts-ignore
const initialState: AchievementsStore = Immutable.fromJS({
  data: Immutable.List(),
  isFetching: false,
  failure: false,
});

const AchievementsReducer = handleActions<any>(
  {
    DASHBOARD_ACHIEVEMENTS_REQUEST: (state: AchievementsStore) => state.set('isFetching', true),

    DASHBOARD_ACHIEVEMENTS_RESPONSE_FAILURE: (state: AchievementsStore) => state.set('isFetching', false).set('failure', true),
    AUTHENTICATION_LOGOUT: () => initialState,
    DASHBOARD_ACHIEVEMENTS_RESPONSE: (state: AchievementsStore, action: AchievementsActionType) =>
      state
        .set('isFetching', false)
        .set('data', Immutable.fromJS(action.payload.data.filter((item: BaseAchievementElement) => item.achieved !== null)))
        .set('failure', false),
  },
  initialState
);

export default AchievementsReducer;
